/**
 * @generated SignedSource<<430459fb8cbcaf5ee445f4dbf377af93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type report_table_data_input = {
  limit?: number | null;
  offset?: number | null;
  order_by?: ReadonlyArray<report_table_order_by> | null;
  query_arguments?: any | null;
  report_params?: any | null;
  report_slug: string;
  search?: string | null;
  table_slug: string;
  where?: any | null;
};
export type report_table_order_by = {
  desc: boolean;
  id: string;
};
export type ReportTableQuery$variables = {
  params: report_table_data_input;
};
export type ReportTableQuery$data = {
  readonly _sys_get_report_table_data: {
    readonly data: ReadonlyArray<any>;
  };
};
export type ReportTableQuery = {
  response: ReportTableQuery$data;
  variables: ReportTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "report_table_output",
    "kind": "LinkedField",
    "name": "_sys_get_report_table_data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportTableQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportTableQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1b6a723be81495fe611c10154b665dc9",
    "id": null,
    "metadata": {},
    "name": "ReportTableQuery",
    "operationKind": "query",
    "text": "query ReportTableQuery(\n  $params: report_table_data_input!\n) {\n  _sys_get_report_table_data(params: $params) {\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b297b9bbfe2141bdc3b8f3c5d5342b3";

export default node;
